export default __webpack_public_path__ + "static/media/pin-green.fbe737de.svg";